import { useState } from "react";
import { toast } from "sonner";
import { Sparkle, Copy, WhatsappLogo, EnvelopeSimple } from "@phosphor-icons/react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Segmented } from "@/components/common";
import { api, errMsg } from "@/lib/api";

export default function CollectionMessageDialog({ open, onOpenChange, account }) {
  const [tone, setTone] = useState("nazik");
  const [busy, setBusy] = useState(false);
  const [res, setRes] = useState(null);

  const gen = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/ai/collection-message", { account_id: account.id, tone }, { timeout: 90000 });
      setRes(data);
    } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  const copy = async () => { await navigator.clipboard.writeText(res.text); toast.success("Mesaj panoya kopyalandı"); };
  const phone = (res?.phone || "").replace(/\D/g, "").replace(/^0/, "90");

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg rounded-[6px]" data-testid="collection-message-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 font-display"><Sparkle weight="fill" className="text-[#fdba74]" /> Tahsilat Mesajı Taslağı</DialogTitle>
          <DialogDescription>Yapay zekâ, carinin açık faturalarına ve bakiyesine göre hatırlatma metni hazırlar. Düzenleyip kopyalayabilir veya WhatsApp/e-posta ile gönderebilirsiniz.</DialogDescription>
        </DialogHeader>
        <div className="flex flex-wrap items-center gap-3">
          <Segmented value={tone} onChange={setTone} prefix="collection-tone" options={[["nazik", "Nazik"], ["resmi", "Resmi"], ["kararli", "Kararlı"]]} />
          <Button onClick={gen} disabled={busy} className="rounded-[4px]" data-testid="collection-generate-button"><Sparkle weight="fill" /> {busy ? "Yazılıyor…" : res ? "Yeniden Yaz" : "Taslak Oluştur"}</Button>
        </div>
        {res && (
          <div className="space-y-3">
            <Textarea rows={8} value={res.text} onChange={(e) => setRes({ ...res, text: e.target.value })} data-testid="collection-message-text" />
            <div className="flex flex-wrap gap-2">
              <Button variant="outline" onClick={copy} className="rounded-[4px]" data-testid="collection-copy-button"><Copy /> Kopyala</Button>
              {phone && <Button asChild variant="outline" className="rounded-[4px] border-[#25D366] text-[#128C7E]" data-testid="collection-whatsapp-button"><a href={`https://wa.me/${phone}?text=${encodeURIComponent(res.text)}`} target="_blank" rel="noreferrer"><WhatsappLogo weight="fill" /> WhatsApp</a></Button>}
              {res.email && <Button asChild variant="outline" className="rounded-[4px]" data-testid="collection-email-button"><a href={`mailto:${res.email}?subject=${encodeURIComponent("Ödeme hatırlatması")}&body=${encodeURIComponent(res.text)}`}><EnvelopeSimple /> E-posta</a></Button>}
            </div>
            <p className="text-xs text-muted-foreground">{res.open_count} açık fatura dikkate alındı.</p>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
